import React from 'react';
import { QRCodeSVG as QRCode} from 'qrcode.react';

function QRCodeGenerator({ value, size }) {
  return (
    <QRCode value={value} size={size} />
  );
}

export default QRCodeGenerator;